var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ads-iframe"},[_c('bar',{staticClass:"bar",attrs:{"my-title":_vm.title}}),_c('iframe',{staticStyle:{"width":"100vw"},style:({ height: `calc(100vh - ${_vm.bar}px)` }),attrs:{"src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }